import type { AccountPayload } from '@Application/Accounts/Actions/accountFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AccountView {
	readonly id: number;
	readonly name: string;

	constructor(payload: AccountPayload) {
		this.id = payload.id;
		this.name = payload.name;

		Object.freeze(this);
	}
}

export default AccountView;
